export default __webpack_public_path__ + "static/fortinet-logo-92360bc7f13f537b88ebe1bdc37bdd54.png";